/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Docs_Search_PlaceholderInputs */

const en_public_docs_search_placeholder = /** @type {(inputs: Public_Docs_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search documents...`)
};

const es_public_docs_search_placeholder = /** @type {(inputs: Public_Docs_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar documentos...`)
};

/**
* | output |
* | --- |
* | "Search documents..." |
*
* @param {Public_Docs_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const public_docs_search_placeholder = /** @type {((inputs?: Public_Docs_Search_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Docs_Search_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_public_docs_search_placeholder(inputs)
	return en_public_docs_search_placeholder(inputs)
});